module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=PG - Papua New Guinea.4f311050.svg";